import React from "react";
import "./FounderSpotlight.css";
import edPic from "../../../images/ed-pic.png";
import decorativeTop from "../../../images/Group 29.png";
import decorativeBottom from "../../../images/Group 28 (1).png";
import awardIcon from "../../../images/mdi_achievement-award.png";

const founderAwards = [
  "Deloitte Fast 50 (6th fastest-growing company in Texas)",
  "Greater Austin Chamber Economic Engine Award",
  "USA Today Top 50 CEOs for SMB (2019)",
  "Multiple Inc. 5000 rankings",
];

const FounderSpotlight = () => {
  return (
    <section className="founder-section">
      <div className="container">
        <div className="founder-card">
          <img
            src={decorativeTop}
            alt=""
            className="founder-decor founder-decor-top"
          />
          <img
            src={decorativeBottom}
            alt=""
            className="founder-decor founder-decor-bottom"
          />

          {/* Desktop / Tablet Layout */}
          <div className="founder-desktop-layout">
            <div className="row g-5 founder-inner-row">
              <div className="col-lg-5">
                <div className="founder-photo-card">
                  <img src={edPic} alt="Ed Sattar" className="founder-photo" />
                </div>

                <div className="founder-bottom-copy">
                  <p className="mt-lg-4">
                    Ed developed QS Learn — a proprietary instructional delivery
                    methodology — and built CLIPP, an AI-powered cognitive
                    learning platform.
                  </p>

                  <p>
                    Today, his focus is building the AI Talent Intelligence
                    infrastructure that will power skills-based hiring and
                    performance-based certification at scale.
                  </p>
                </div>
              </div>

              <div className="col-lg-7 pt-lg-5">
                <div className="founder-content">
                  <h2 className="founder-heading">Ed Sattar – Founder</h2>

                  <p className="founder-copy">
                    Ed is a workforce development evangelist and serial EdTech
                    founder who has pioneered skills-based performance-driven
                    learning for over 20 years.
                  </p>

                  <p className="founder-copy">
                    Three-time Ernst &amp; Young Entrepreneur of the Year nominee
                    and 2009 top-seven finalist, Ed has led organizations to:
                  </p>

                  <ul className="founder-awards">
                    {founderAwards.map((award, index) => (
                      <li key={index}>
                        <img
                          src={awardIcon}
                          alt=""
                          className="founder-award-icon"
                        />
                        <span>{award}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Mobile Layout */}
          <div className="founder-mobile-layout">
            <div className="founder-inner-row">
              <div className="founder-photo-card founder-photo-card-mobile">
                <img src={edPic} alt="Ed Sattar" className="founder-photo" />
              </div>

              <div className="founder-content founder-content-mobile">
                <h2 className="founder-heading">Ed Sattar – Founder</h2>

                <p className="founder-copy">
                  Ed is a workforce development evangelist and serial EdTech
                  founder who has pioneered skills-based performance-driven
                  learning for over 20 years.
                </p>

                <p className="founder-copy">
                  Three-time Ernst &amp; Young Entrepreneur of the Year nominee
                  and 2009 top-seven finalist, Ed has led organizations to:
                </p>

                <ul className="founder-awards">
                  {founderAwards.map((award, index) => (
                    <li key={index}>
                      <img
                        src={awardIcon}
                        alt=""
                        className="founder-award-icon"
                      />
                      <span>{award}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="founder-bottom-copy founder-bottom-copy-mobile">
                <p>
                  Ed developed QS Learn — a proprietary instructional delivery
                  methodology — and built CLIPP, an AI-powered cognitive
                  learning platform.
                </p>

                <p>
                  Today, his focus is building the AI Talent Intelligence
                  infrastructure that will power skills-based hiring and
                  performance-based certification at scale.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FounderSpotlight;